"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Grid = _interopRequireDefault(require("../Grid/Grid"));

var _MuiButtonRedirect = _interopRequireDefault(require("../MuiButtonRedirect/MuiButtonRedirect"));

var _MuiCard = _interopRequireDefault(require("../MuiCard/MuiCard"));

var _MuiTypography = _interopRequireDefault(require("../MuiTypography/MuiTypography"));

var _MuiMenu = _interopRequireDefault(require("../MuiMenu/MuiMenu"));

var _MuiIcon = _interopRequireDefault(require("../MuiIcon/MuiIcon"));

var _MuiAccordion = _interopRequireDefault(require("../MuiAccordion/MuiAccordion"));

var _MuiList = _interopRequireDefault(require("../MuiList/MuiList"));

var _MuiTable = _interopRequireDefault(require("../MuiTable/MuiTable"));

var _MuiPaginationTable = _interopRequireDefault(require("../MuiPaginationTable/MuiPaginationTable"));

var _MuiContactButton = _interopRequireDefault(require("../MuiContactButton/MuiContactButton"));

var _MuiImage = _interopRequireDefault(require("../MuiImage/MuiImage"));

var _BlokForm = _interopRequireDefault(require("../BlokForm/BlokForm"));

var _MuiAudioPlayer = _interopRequireDefault(require("../MuiAudioPlayer/MuiAudioPlayer"));

var _MuiIconButtonDialog = _interopRequireDefault(require("../MuiIconButtonDialog/MuiIconButtonDialog"));

var _MuiButtonDialog = _interopRequireDefault(require("../MuiButtonDialog/MuiButtonDialog"));

var _customProps = require("../../utils/customProps");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var MuiHeroHeader = function MuiHeroHeader(props) {
  var components = {
    MuiButtonRedirect: _MuiButtonRedirect.default,
    MuiCard: _MuiCard.default,
    MuiTypography: _MuiTypography.default,
    MuiMenu: _MuiMenu.default,
    MuiIcon: _MuiIcon.default,
    MuiAccordion: _MuiAccordion.default,
    MuiList: _MuiList.default,
    MuiTable: _MuiTable.default,
    MuiPaginationTable: _MuiPaginationTable.default,
    MuiContactButton: _MuiContactButton.default,
    BlokForm: _BlokForm.default,
    MuiImage: _MuiImage.default,
    MuiAudioPlayer: _MuiAudioPlayer.default,
    MuiIconButtonDialog: _MuiIconButtonDialog.default,
    MuiButtonDialog: _MuiButtonDialog.default
  };
  var heroClass = {
    height: props.height,
    position: 'relative',
    padding: 0,
    margin: 0
  };

  if (props.backgroundImageUrl) {
    heroClass = _objectSpread(_objectSpread({}, heroClass), {
      backgroundImage: "url(".concat(props.backgroundImageUrl, ")"),
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'cover'
    });
  }

  return /*#__PURE__*/_react.default.createElement(_Grid.default, (0, _extends2.default)({}, props, {
    style: heroClass,
    components: components
  }));
};

var _default = MuiHeroHeader;
exports.default = _default;
MuiHeroHeader.propTypes = {
  /** url for background img */
  backgroundImageUrl: _propTypes.default.string,

  /** height of the container */
  height: function height(props, propName, componentName) {
    return (0, _customProps.dimensionProp)(props, propName, componentName);
  }
};
MuiHeroHeader.defaultProps = {
  height: '100%',
  backgroundImageUrl: ''
};